document.addEventListener("DOMContentLoaded", function () {

  const popup = document.getElementById("edd-newsletter-popup");
  if (!popup) return;

  /* ─────────────────────────────
     No volver a mostrar
  ───────────────────────────── */
  if (localStorage.getItem("edd_newsletter_popup_shown")) {
    popup.remove();
    return;
  }

  const form = document.getElementById("edd-klaviyo-form");
  const emailInput = document.getElementById("edd-klaviyo-email");
  const successMsg = popup.querySelector(".edd-nl-success");
  const closeBtn = popup.querySelector(".edd-nl-close");

  /* ─────────────────────────────
     Mostrar popup
  ───────────────────────────── */
  setTimeout(() => {
    popup.style.display = "grid";
  }, 3000);

  /* ─────────────────────────────
     Cerrar manual
  ───────────────────────────── */
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      /* localStorage.setItem("edd_newsletter_popup_shown", "true"); */
      popup.remove();
    });
  }

  if (!form || !emailInput) return;

  /* ─────────────────────────────
     Envío a Klaviyo (CORRECTO)
  ───────────────────────────── */
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const email = emailInput.value.trim();
    if (!email) return;

    const data = new URLSearchParams();
    data.append("g", "VyET3z");
    data.append("email", email);
    data.append("$source", "Shopify Popup");

    fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: data.toString()
    })
    .then(response => {
      if (!response.ok) {
        throw new Error("Klaviyo error");
      }
      return response.text();
    })
    /**
     * .then(() => {
      successMsg.style.display = "block";
      localStorage.setItem("edd_newsletter_popup_shown", "true");

      setTimeout(() => {
        popup.remove();
      }, 1500);
    }) */

    .then(() => {
  successMsg.style.display = "block";
  localStorage.setItem("edd_newsletter_popup_shown", "true");

  const coupon = popup.dataset.coupon;
  const redirect = popup.dataset.redirect || "/";

  setTimeout(() => {
    if (coupon) {
      window.location.href = `/discount/${coupon}?redirect=${redirect}`;
    } else {
      window.location.href = redirect;
    }
  }, 1200);
})

    .catch(() => {
      alert("No se pudo registrar el correo. Intenta nuevamente.");
    });
  });

});
